import { render, staticRenderFns } from "./StandardDialog.vue?vue&type=template&id=716f3996"
import script from "./StandardDialog.vue?vue&type=script&lang=js"
export * from "./StandardDialog.vue?vue&type=script&lang=js"
import style0 from "./StandardDialog.vue?vue&type=style&index=0&id=716f3996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports